module.exports = __webpack_public_path__ + "img/case_02.ad30e468.jpg";